import { IApiService } from 'src/services/IApiService';
import {observable} from "mobx";
import RESTApiService from "../services/RESTApiService";

export default class ReportStore {

    public report: any[] = [];
    @observable public smartEmailingCount: number = 0;

    private api: RESTApiService;
    constructor(api: RESTApiService) {
        this.api = api;
    }

    public loadEmailsCount(): Promise<boolean> {
        return new Promise(resolve => {
            this.api.getNewEmailsCount()
                .then(count => {
                    this.smartEmailingCount = count;
                    resolve(true);
                })
        });
    }

    public getEmailsCSVUrl() {
        return this.api.getRestUrl("/report/smartEmailing/data");
    }

    public loadMealsToMakeReport(date: Date): Promise<boolean> {
        this.report = [];
        return new Promise(resolve => {
            this.api.getMealsToMakeReport(date)
                .then(report => {
                    report.forEach(item => {
                        this.report.push(item);
                    });
                    resolve(true);
                });
        });
    }

    public getMealsToMakeXlsxUrl(date: Date) {
        return this.api.getRestUrl("/report/mealsToMake/" + this.formatDate(date) + "/xlsx");
    }

    private formatDate(date: Date): string {
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    }
}


// WEBPACK FOOTER //
// ./src/stores/ReportStore.tsx